import React from 'react';
import { Question } from 'models/Questionnaire';
import { Row } from 'react-bootstrap';
import { Col } from 'react-bootstrap';
import { QuestionSlider } from './QuestionSlider';
import Separator from './Separator';
import { ValueResource } from 'models/QuestionnaireResource';


export const AnswerSectionField = (props: { answers: Question[], title: string | undefined }) => {

	return (
		<React.Fragment>
			<Row noGutters>
				<h3>{props.title}</h3>
				<Separator className='result-header-separator' />
			</Row>
			<Row noGutters>
				<Col xs='12' className='result-answer-container'>
					{
						props.answers.map((question, index, arr) => {
							const last = index === arr.length - 1;
							return (
								<div className='result-answer' key={`answer${question.id}`}>
									<Col sm='3' md='4' xs='12' className='question-text'>
										<p>{question.title}</p>
									</Col>
									<Col sm='9' md='8' xs='12' className={`d-flex justify-content-center ${!last && 'mb-2'}`}>
										<QuestionSlider currentValue={question.answer?.primary}
											answerValue={question.category.values?.primary as ValueResource}
											disabled={true}
											title={question.category.questiontitle}
											idPrefix={question.id} />
									</Col>
									{
										!last &&
										<Separator className='result-answer-separator' />
									}
								</div>
							)
						})
					}
				</Col>
			</Row>
		</React.Fragment>
	)
} 